/** Sidebar wordmark/icon, replacing the stock TailAdmin template logo — uses the
 * brand tokens (`--primary`/`--accent`, ALAS blue/gold) from `styles/global.css`. */
function Mark({ size }: { size: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 2c4.5 3.6 7 8.9 7 14.5 0 2.6-.5 5-1.4 7.2l-5.6 4.3-5.6-4.3C9.5 21.5 9 19.1 9 16.5 9 10.9 11.5 5.6 16 2Z"
        fill="var(--primary)"
      />
      <circle cx="16" cy="14" r="2.6" fill="var(--accent)" />
    </svg>
  )
}

export function SateLabLogo({ showLabel }: { showLabel: boolean }) {
  if (!showLabel) return <Mark size={32} />
  return (
    <span className="flex items-center gap-2">
      <Mark size={32} />
      <span className="text-lg font-bold tracking-tight text-gray-900 dark:text-white">SateLab</span>
    </span>
  )
}
